import React from "react"
import Block from "@bappweb/block"
import MainForm from "./form"
import QrCode from "./qrcode"

const Landing = () => {
  return (
    <Block className="form">
      <MainForm />
      <QrCode />
    </Block>
  )
}

export default Landing
